module.exports = __webpack_public_path__ + "static/5-240bfc9635054b5022b2aa1f58830e53.jpg";